import { createFileRoute } from '@tanstack/react-router'
import { ConnectionManager } from '../../../../features/admin/ConnectionManager'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/collection/connections',
)({
  component: AdminCollectionConnectionsRoute,
})

/* ───── Route Component ───── */

function AdminCollectionConnectionsRoute() {
  return <ConnectionManager />
}
